import { getJSONPost } from '@/util/url'
import { STATUS_COMPLETED, UPGRADED_ONBOARDING, UserExperienceCollection } from './experience'

const parseJson = async <T>(response: Response): Promise<T | undefined> => {
    const contentType = response.headers.get('content-type')
    if (!contentType?.includes('application/json')) {
        return undefined
    }

    return (await response.json()) as T
}

const assertOk = async (response: Response) => {
    if (!response.ok) {
        throw new Error(`Upgraded onboarding request failed with ${response.status}`)
    }
}

export const getUserExperiences = async (signal?: AbortSignal) => {
    const response = await fetch('/api/v3/users/experiences/mine/', {
        credentials: 'same-origin',
        signal,
    })
    await assertOk(response)
    return parseJson<UserExperienceCollection>(response)
}

export const updateUserExperience = async (experienceId: string, status: number) => {
    const response = await fetch('/api/v3/users/experiences', {
        ...getJSONPost({
            experience_id: experienceId,
            status,
        }),
        credentials: 'same-origin',
    })
    await assertOk(response)
    return parseJson<unknown>(response)
}

export const completeUpgradedOnboardingExperience = () => {
    return updateUserExperience(UPGRADED_ONBOARDING, STATUS_COMPLETED)
}
